import { render, staticRenderFns } from "./ShopManage.vue?vue&type=template&id=10f0ab4c&scoped=true&"
import script from "./ShopManage.vue?vue&type=script&lang=js&"
export * from "./ShopManage.vue?vue&type=script&lang=js&"
import style0 from "./ShopManage.vue?vue&type=style&index=0&id=10f0ab4c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0ab4c",
  null
  
)

export default component.exports